import { constants } from "../constants";

export const DEFAULT_STATE = {
  isEvoOnlyMode: false,
  flagsLoaded: false
};

const featureFlags = (state = DEFAULT_STATE, { type, payload } = {}) => {
  switch (type) {
    case constants.SET_FEATURE_FLAGS:
      return {
        ...state,
        isEvoOnlyMode: payload["reg_evo_only_mode_enabled"] ?? false,
        flagsLoaded: true
      };
    default:
      return state;
  }
};

export default featureFlags;
